import { defineMessages } from 'utils/intl';

export default defineMessages({
  productCode: 'Kod produktu: {productCode}',
  producerPn: 'Kod producenta: {producerPn}',
  manufacturer: 'Producent: {manufacturer}',
  configuration: 'Konfiguracja: {configurationCode}',
});
